import { NgModule } from '@angular/core';

import { PlannerModule } from './planner/planner.module';
import { RoutePlannerRoutingModule } from './route-planner-routing.module';
import { RoutePlannerComponent } from './route-planner.component';

@NgModule({
    declarations: [RoutePlannerComponent],
    imports: [PlannerModule, RoutePlannerRoutingModule]
})
export class RoutePlannerModule {}
